module.exports = __webpack_public_path__ + "media/images/lb/840-0746e64eae53e882db35cdf510eca887.svg";